<template>
    <div class="root d-inline-block">
        <!-- <button class="btn btn-success btn-block" @click="btnClicked">{{text}}</button> -->
        <toggle-button @change="btnClicked"  :value="!isActive" color="#82C7EB" :width="70" :height="25" :sync="true"
        :labels="{checked: 'ویرایش', unchecked: 'ویرایش'}"/>
    </div>
</template>

<script>
import EventBus from "../_framework/bus.js";
import ToggleButton from "vue-js-toggle-button/src/Button";

export default {
  name: "toggle-table-actions-button",
  components: {
    ToggleButton
  },
  props: ["header", "params", "th"],
  data() {
    return {
      isActive: false,
      text: "ویرایش"
    };
  },
  methods: {
    btnClicked() {

      this.isActive = !this.isActive;
      this.text = this.isActive ? "نمایش" : "ویرایش";
      this.params.onClick();
      // console.log(this.params)
    }
  }
};
</script>

<style scoped>
.vue-js-switch {
  font-size: 12px;
}
</style>
